<template>
  <div class="fabless">
    <md-app md-waterfall md-mode="fixed">
      <md-app-toolbar md-elevation="4" class="md-transparent md-dense o-modal">
        <div class="md-toolbar-section-start">
          <md-button class="md-icon-button" @click="dismiss = true"><md-icon>arrow_back</md-icon></md-button>
          <md-dialog :md-active.sync="dismiss">
            <md-dialog-title>{{ translate(thingsToTranslate.confirm.title) }}</md-dialog-title>
            <md-dialog-content>
              {{ translate(thingsToTranslate.confirm.content) }}
            </md-dialog-content>
            <md-dialog-actions>
              <md-button class="" @click="navigateBack">{{ translate(thingsToTranslate.confirm.cancel) }}</md-button>
              <md-button class="" @click="saveMomentHandle">{{ translate(thingsToTranslate.confirm.proceed) }}</md-button>
            </md-dialog-actions>
          </md-dialog>
        </div>
        <h1></h1>
        <div class="md-toolbar-section-end">
          <md-button class="md-icon-button" @click="entry.flagged = !entry.flagged">
            <md-icon class="flagged" v-if="entry.flagged">bookmark</md-icon>
            <md-icon v-else>bookmark_border</md-icon>
          </md-button>
          <md-button v-if="entry.id" class="md-icon-button" @click="deleteMomentHandle(entry.id)"><md-icon class="">delete</md-icon></md-button>
          <md-button class="md-icon-button" @click="saveMomentHandle"><md-icon class="">check</md-icon></md-button>
        </div>
      </md-app-toolbar>

      <md-app-content class="c-form o-modal">
        <div class="md-layout md-alignment-center-space-between">
          <div class="md-layout-item md-size-100">
            <md-field class="c-header-media">
              <img v-if="mediaSrc" :src="mediaSrc | resizeImage({ height: 125, width: 800, crop: 'fill' })" />
              <label class="u-label--static"><md-icon>photo_camera</md-icon></label>
              <md-file @md-change="mediaSelectedHandle($event)" accept="image/*;capture=camera"></md-file>
            </md-field>
          </div>
          <md-field class="md-layout-item md-size-40 filled">
            <label>{{ translate(thingsToTranslate.timeLabel) }}</label>
            <md-input v-model="entryTime" type="time"></md-input>
          </md-field>
          <md-datepicker class="md-layout-item md-size-50" v-model="entryDate" md-immediately />

          <md-field class="md-layout-item md-size-40 c-field--select" @click="showMoments = true" :class="{ filled: entryType }">
            <md-button :md-ripple="false" @click="showMoments = true"></md-button>
            <md-dialog :md-active.sync="showMoments">
              <md-dialog-title>{{ translate(thingsToTranslate.title) }}</md-dialog-title>
              <md-dialog-content>
                <md-checkbox
                  v-model="entryType"
                  :value="momentType.id"
                  v-for="(momentType, index) in momentTypesSorted"
                  :key="index"
                  @change="showMoments = false"
                  >{{ translate(momentType.name) }}
                </md-checkbox>
              </md-dialog-content>
              <md-dialog-actions>
                <md-button class="" @click="showMoments = false">done</md-button>
              </md-dialog-actions>
            </md-dialog>
            <label for="meal-type">{{ translate(thingsToTranslate.momentLabel) }}</label>
            <span v-if="entryType">{{ translate(momentTypeRepository.getById(entryType).name) }}</span>
          </md-field>

          <md-switch class="md-layout-item md-size-40" v-model="entry.skipped">{{ translate(thingsToTranslate.skippedLabel) }}</md-switch>

          <md-field class="md-layout-item md-size-40 c-field--select" @click="showLocations = true" :class="{ filled: entry.location }">
            <md-button :md-ripple="false" @click="showLocations = true"></md-button>
            <md-dialog :md-active.sync="showLocations">
              <md-dialog-title>{{ translate(thingsToTranslate.locationLabel) }}</md-dialog-title>
              <md-dialog-content>
                <md-checkbox v-model="entry.location" :value="location.id" v-for="(location, index) in locations" :key="index" @change="showLocations = false">
                  {{ translate(location.name) }}
                </md-checkbox>
              </md-dialog-content>
              <md-dialog-actions>
                <md-button class="" @click="showLocations = false">done</md-button>
              </md-dialog-actions>
            </md-dialog>
            <label>{{ translate(thingsToTranslate.locationLabel) }}</label>
            <span v-if="entry.location">{{ translate(this.locationRepository.getById(entry.location).name) }}</span>
          </md-field>
          <md-field class="md-layout-item md-size-50 c-field--select" @click="showParties = true" :class="{ filled: entry.party }">
            <md-button :md-ripple="false" @click="showParties = true"></md-button>
            <md-dialog :md-active.sync="showParties">
              <md-dialog-title>{{ translate(thingsToTranslate.partyLabel) }}</md-dialog-title>
              <md-dialog-content>
                <md-checkbox v-model="entry.party" :value="party.id" v-for="(party, index) in parties" :key="index" @change="showParties = false">
                  {{ translate(party.name) }}
                </md-checkbox>
              </md-dialog-content>
              <md-dialog-actions>
                <md-button class="" @click="showParties = false">done</md-button>
              </md-dialog-actions>
            </md-dialog>
            <label>{{ translate(thingsToTranslate.partyLabel) }}</label>
            <span v-if="entry.party">{{ translate(this.partyRepository.getById(entry.party).name) }}</span>
          </md-field>

          <md-field class="md-layout-item md-size-100" v-if="!entry.skipped" :class="{ filled: entry.summary && entry.summary.length }">
            <label>{{ translate(thingsToTranslate.whatLabel) }}</label>
            <wc-textarea v-model="entry.summary"></wc-textarea>
          </md-field>

          <md-field class="md-layout-item md-size-100 u-transform-to-pills c-field--select filled">
            <label>{{ translate(thingsToTranslate.emotionLabel) }}</label>
            <span>
              <md-chip
                class="md-primary"
                :class="getSelected(entry.emotions, emotion.id)"
                @click="setSelected(entry.emotions, emotion.id)"
                v-for="(emotion, index) in emotionsSorted"
                :key="index"
                md-clickable
              >
                {{ emotion.emoji }} <span> {{ translate(emotion.name) }}</span>
              </md-chip>
            </span>
          </md-field>
          <md-field :class="{ filled: entry.description && entry.description.length }">
            <label>{{ translate(thingsToTranslate.descriptionLabel) }}</label>
            <wc-textarea v-model="entry.description"></wc-textarea>
          </md-field>
          <md-field class="md-layout-item md-size-100 u-transform-to-pills c-field--select filled">
            <label for="meal-behaviour">{{ translate(thingsToTranslate.behaviourLabel) }}</label>
            <span>
              <md-chip
                class="md-accent"
                :class="getSelected(entry.behaviour, behaviour.id)"
                @click="setSelected(entry.behaviour, behaviour.id)"
                v-for="(behaviour, index) in behaviours"
                :key="index"
                md-clickable
              >
                <span>{{ translate(behaviour.name) }}</span>
              </md-chip>
            </span>
          </md-field>
        </div>
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
import { mapState } from "vuex";
import momentService from "../services/momentservice";

import * as repos from "../contentrepositories";
import { navigate, translate, googleTags } from "../mixins";

import wcTextArea from "./elements/WcTextArea";

export default {
  name: "AddMoment",
  mixins: [navigate, translate, googleTags],
  components: {
    "wc-textarea": wcTextArea
  },
  watch: {
    $route() {
      this.entry = this.getEmptyEntry();
      this.loadEntryData();
    },
    user() {
      this.entry = this.getEmptyEntry();
      this.loadEntryData();
    }
  },
  computed: {
    ...mapState(["user", "selectedDate"]),
    momentTypeRepository() {
      return repos.momentTypeRepository;
    },
    momentTypesSorted() {
      return this.momentTypeRepository.getAll(this.$store.state.locale);
    },
    emotionsSorted() {
      return repos.emotionRepository.getAll(this.$store.state.locale);
    },
    locations() {
      return repos.locationRepository.getAll(this.$store.state.locale);
    },
    parties() {
      return repos.partyRepository.getAll(this.$store.state.locale);
    },
    locationRepository() {
      return repos.locationRepository;
    },
    partyRepository() {
      return repos.partyRepository;
    },
    behaviours() {
      return repos.behaviourRepository.getAll(this.$store.state.locale);
    },
    selectedBehaviour() {
      return id => this.behaviourRepository.getById(id);
    },
    warnings() {
      return this.entry.behaviour.length > 0 || this.entry.skipped === true;
    },
    entryType: {
      get() {
        if (this.momentPicked) {
          return this.entry.type;
        }
        const result =
          this.momentTypeRepository
            .getAll()
            .slice()
            .reverse()
            .find(h => h.start <= (this.entry.dateTime || this.selectedDate).getHours()) || this.momentTypeRepository.getAll()[0];

        return result ? result.id : null;
      },
      set(id) {
        this.$set(this.entry, "type", id);
        this.momentPicked = true;
      }
    },
    entryTime: {
      get() {
        return this.$date(this.entry.dateTime, "HH:mm");
      },
      set(value) {
        if (!value) {
          return;
        }
        const params = value.split(":").map(i => parseInt(i, 10));
        const newdate = new Date(this.entry.dateTime);
        newdate.setHours(params[0], params[1], 0);
        this.$set(this.entry, "dateTime", newdate);
      }
    },
    entryDate: {
      get() {
        return this.entry.dateTime;
      },
      set(value) {
        value.setHours(this.entry.dateTime.getHours(), this.entry.dateTime.getMinutes());
        this.$set(this.entry, "dateTime", value);
      }
    },
    mediaSrc() {
      if (this.mediaData) {
        return this.mediaData;
      }
      if (this.entry.media) {
        return this.entry.media;
      }
      return "";
    }
  },
  mounted() {
    this.loadEntryData();
    this.gTagScreenView("MomentEntry");
  },
  data() {
    return {
      entry: this.getEmptyEntry(),
      showMoments: false,
      showLocations: false,
      showParties: false,
      momentPicked: this.$route.params.momentId,
      newMoment: true,
      dismiss: false,
      mediaData: null,
      height: "auto",
      thingsToTranslate: {
        title: {
          en: "This moment",
          nl: "Dit moment"
        },
        timeLabel: {
          en: "Time",
          nl: "Tijd"
        },
        momentLabel: {
          en: "Moment",
          nl: "Moment"
        },
        partyLabel: {
          en: "Who were you with?",
          nl: "Met wie was je?"
        },
        skippedLabel: {
          en: "Skipped",
          nl: "Overgeslagen"
        },
        whatLabel: {
          en: "What did you eat?",
          nl: "Wat heb je gegeten?"
        },
        locationLabel: {
          en: "Where were you?",
          nl: "Waar was je?"
        },
        emotionLabel: {
          en: "Emotions",
          nl: "Welke gevoelens had je?"
        },
        descriptionLabel: {
          en: "What's going on in your head?",
          nl: "Wat gaat er door je hoofd?"
        },
        behaviourLabel: {
          en: "Behaviour",
          nl: "Acties"
        },
        confirm: {
          title: {
            en: "Are you sure?",
            nl: "Weet je het zeker?"
          },
          content: {
            en: "You are about to go back without saving. All changes will be lost.",
            nl: "Je gaat terug zonder je gegevens op te slaan. Alle wijzigingen gaan dan verloren."
          },
          proceed: {
            en: "save first",
            nl: "eerst opslaan"
          },
          cancel: {
            en: "don't save",
            nl: "niet opslaan"
          }
        }
      }
    };
  },
  methods: {
    saveMomentHandle() {
      this.entry.warningSigns = this.warnings;
      this.entry.type = this.entryType;
      momentService.saveMoment(this.entry).then(() => this.$router.push({ path: "/" }));
    },
    deleteMomentHandle(id) {
      momentService.deleteMoment(id).then(() => this.$router.push({ path: "/" }));
    },
    mediaSelectedHandle(evt) {
      const first = 0;
      this.$set(this.entry, "media", evt[first]);
      const reader = new FileReader();
      reader.onload = e => {
        this.mediaData = e.target.result;
      };
      reader.readAsDataURL(evt[first]);
    },
    getEmptyEntry() {
      return {
        userId: this.user ? this.user.userId : "",
        dateTime: this.selectedDate,
        type: null,
        skipped: false,
        location: null,
        party: null,
        media: null,
        summary: "",
        description: "",
        behaviour: [],
        emotions: [],
        flagged: false,
        warningSigns: false
      };
    },
    loadEntryData() {
      if (this.$route.params.momentId) {
        this.newMoment = false;
        momentService.getMomentById(this.$route.params.momentId).then(result => {
          this.entry = result || this.getEmptyEntry();
        });
      } else {
        this.entry = this.getEmptyEntry();
      }
    },
    getSelected(entries, id) {
      return { selected: entries.includes(id) };
    },
    setSelected(entries, id) {
      const indexOfId = entries.indexOf(id);
      if (indexOfId <= 0 && !entries.includes(id)) {
        entries.push(id);
      } else {
        entries.splice(indexOfId, 1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/libs.vuematerial-forms.scss";
@import "../assets/styles/libs.vuematerial-cards.scss";

.c-header-media {
  width: auto;
  margin: -16px -16px 1rem -16px;
}

.c-form {
  --md-theme-default-accent: var(--color-error-2);
  --md-theme-default-accent-on-: var(--color-error);
}

.md-content {
  height: auto;
  --md-theme-default-background: #fff;
  border-right: 1px solid var(--md-theme-default-divider-on-background, rgba(0, 0, 0, 0.12));
}

.md-datepicker {
  & ::v-deep .md-input {
    -webkit-appearance: none;
    max-width: calc(100% - 24px);
    padding: 0;
  }
}
.u-transform-to-pills {
  ::v-deep .md-ripple {
    display: flex;
    font-size: 22px;

    span {
      margin-left: 0.2rem;
      font-size: 13px;
    }
  }
}
</style>
